import { EntityDefinition } from "ips/ac/model/types/EntityDefinition";

const InternalOrderStatusDefinition: EntityDefinition = {
  ENTITY_SET: "InternalOrderStatuses",
};
export default InternalOrderStatusDefinition;
